import {
  Badge,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@tinct/web-components';
import { useOpenPaywall } from '@tinct/web-feature-payment';
import { IconKey } from '@tabler/icons-react';

/**
 * What a workspace that is not entitled to single sign-on sees. It fetches no SSO setting at all:
 * every one of those calls would answer 404, and there is nothing to show anyway.
 */
export function SsoUpsellCard() {
  const { openPaywall } = useOpenPaywall();

  return (
    <Card className="rounded-2xl">
      <CardHeader>
        <div className="flex items-center gap-3">
          <CardTitle className="text-xl">Single sign-on</CardTitle>
          <Badge variant="important">Enterprise</Badge>
        </div>
        <CardDescription>
          Let your team sign in with your own identity provider — Okta, Entra
          ID, Google Workspace or any OpenID Connect and SAML provider.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <div className="flex items-start gap-3 text-sm text-muted-foreground">
          <IconKey className="mt-0.5 size-5 shrink-0" />
          <span>
            Claim your e-mail domains, provision accounts at first sign-in, and
            make your identity provider the only way into this workspace.
          </span>
        </div>
        <div>
          <Button type="button" onClick={() => openPaywall('sso')}>
            Talk to sales
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
